export class HeaderController {
    config;
    userConfig;
    static $inject = ['CONFIG'];
    constructor(config) {
        this.config = config;
        this.userConfig = window['UserConfig'];
    }
    useThreemaFont() {
        return !this.config.SELF_HOSTED || this.userConfig.FONT_CSS_URL !== null;
    }
    fontUrl() {
        if (this.userConfig.FONT_CSS_URL === null) {
            return 'https://static.threema.ch/fonts/labgrotesque.css';
        }
        else {
            return this.userConfig.FONT_CSS_URL;
        }
    }
}
